export class SelectOption {
  constructor(
    public displayName: string,
    public value: string,
    public className?: string
  ) {}
}
